import React from 'react';
import PropTypes from 'prop-types';
import './Alert.scss';

const Alert = ({ message, type }) => {
  return <div className={`alert ${type}`}>{message}</div>;
};

Alert.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'success']).isRequired
};

export default Alert;
